// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__ae6HD","boxTitle":"Qualiphy_boxTitle__1zNiS","box":"Qualiphy_box__3nY2V","toggleWrap":"Qualiphy_toggleWrap__2UPAD"};